import Blue from "~/core";

new Blue({
	name: 'Back to Top',
	selector: ".back-to-top",
	setup(btn) {
    let lastKnownScrollPosition = 0;
    let animFrame;
    let isShowing = false;

    addListeners();
    btn.classList.add('loaded');

    // Supporting functions 

    function addListeners() {
      window.addEventListener('scroll', onScroll);
      btn.addEventListener('click', onClick);
    }

    function onScroll(e) {
      lastKnownScrollPosition = window.scrollY;

      if (!animFrame) {
        animFrame = window.requestAnimationFrame(function() {
          updateShowing();
          animFrame = null;
        });
      }
    }

    function onClick(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } 

    function updateShowing() {
      if (!isShowing && lastKnownScrollPosition > 500 && !isShowing) {
        btn.classList.add('showing');
        isShowing = true;
      } else if (isShowing && lastKnownScrollPosition <= 500) {
        btn.classList.remove('showing');
        isShowing = false;
      }
    }
	}
});
